import { Component, Input } from '@angular/core';
import { ReportInfo, ReportRecord, ReportView, TemplateProjectionMap } from '../../../../models/report.model';
import { TemplateField } from '../../../../models/template.model';

@Component({
  selector: 'ppt-record-header',
  templateUrl: './record-header.component.html',
  styleUrls: ['./record-header.component.scss'],
  standalone: false,
})
export class RecordHeaderComponent {
  @Input() reportRecordData: ReportRecord;
  @Input() reportData: ReportInfo;
  @Input() currentView: ReportView;
  @Input() headerFields: TemplateField[];
  @Input() templateProjectionMap: TemplateProjectionMap;
}
